import axios from 'axios';
import { AuthResponse } from '../types/api';

const API_URL = 'https://app.childstorytime.ai/api';
// const API_URL = 'http://localhost/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        
        // Only add token if it exists and we're not making an auth request
        if (token && !config.url?.includes('/auth/login/')) {
            config.headers = {
                ...config.headers,
                Authorization: `Bearer ${token}`
            };
        }
        
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // If the error is due to an invalid token and we haven't tried to refresh yet
        if (error.response?.status === 401 && 
            error.response?.data?.code === 'token_not_valid' && 
            !originalRequest._retry &&
            originalRequest.url !== '/auth/token/refresh/') {
            
            originalRequest._retry = true;
            try {
                const refreshToken = localStorage.getItem('refresh');
                if (!refreshToken) {
                    throw new Error('No refresh token available');
                }

                // Try to get a new token
                const response = await api.post('/auth/token/refresh/', {
                    refresh: refreshToken
                });
                
                const data = response.data as AuthResponse;
                if (data.access) {
                    localStorage.setItem('token', data.access);
                    
                    // Update the original request with new token
                    originalRequest.headers.Authorization = `Bearer ${data.access}`;
                    return api(originalRequest);
                }
            } catch (refreshError) {
                // Clear auth data and redirect to login
                localStorage.clear();
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        // If refresh token request fails, don't retry
        if (error.response?.status === 401 && 
            originalRequest.url === '/auth/token/refresh/') {
            localStorage.clear();
            window.location.href = '/login';
            return Promise.reject(error);
        }

        return Promise.reject(error);
    }
);

export default api; 